export type ValueOf<T> = T[keyof T];

export const PlugType = Object.freeze({
  Type1: 'Type1',
  Type2: 'Type2',
  Type2s: 'Type2s',
  Type3a: 'Type3a',
  Type3c: 'Type3c',
  // TeslaR = 'TeslaR',
  // Tesla = 'Tesla',
  CHAdeMO: 'CHAdeMO',
  Combo1: 'Combo1',
  Combo2: 'Combo2',
  // EUSchuko = 'EU-Schuko',
  // Mema515 = 'Mema5-15',
  // Mema1550 = 'Mema15-50',
  // UKDomestic = 'UKDomestic',
  // AUDomestic = 'AUDomestic',
  // InsustrialMonophasic = 'InsustrialMonophasic',
  // InsustrialTriphasic = 'InsustrialTriphasic',
});

export type PlugTypeValues = ValueOf<typeof PlugType>;
export type PlugTypeKeys = keyof typeof PlugType;